import React from 'react';
import ToolCard from '../Shared/ToolCard';
import { motion } from 'framer-motion';

const AdditionalTools = () => {
  const tools = [
    {
      icon: 'fa-user-check',
      iconColor: 'text-accent-green bg-accent-green',
      title: 'Account Checker',
      description: 'Check Minecraft accounts for validity and password matching from database.',
      stats: [],
      gradientClass: 'gradient-bg-green',
      path: '/account-checker'
    },
    {
      icon: 'fa-server',
      iconColor: 'text-accent-blue bg-accent-blue',
      title: 'Servers Database',
      description: 'Browse our database of available servers to test with instant connection.',
      stats: [
        { label: 'Available', value: '1,247', colorClass: 'text-accent-blue' },
        { label: 'Updated', value: '2 min ago', colorClass: 'text-white' },
      ],
      gradientClass: 'gradient-bg-blue',
      path: '/servers'
    },
    {
      icon: 'fa-mask',
      iconColor: 'text-accent-pink bg-accent-pink',
      title: 'Secret Method',
      description: 'Our proprietary testing method with the highest success rate for server access.',
      stats: [],
      gradientClass: 'gradient-bg-pink',
      path: '/secret',
      customContent: (
        <div className="flex justify-between items-center">
          <div className="text-xs text-gray-500">
            <span>Premium Only</span>
          </div>
          <button className="bg-dark-500 text-accent-pink px-3 py-1 rounded-lg text-xs font-medium border border-accent-pink transition-medium hover:bg-accent-pink hover:text-dark-800">
            Unlock
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="mb-8 transform-gpu transition-medium hover:scale-[1.005]">
      <h2 className="text-2xl font-bold mb-5 flex items-center group">
        <div className="w-10 h-10 rounded-lg bg-accent-blue/20 flex items-center justify-center mr-3 transform-gpu group-hover:rotate-12 transition-medium">
          <i className="fas fa-tools text-accent-blue"></i>
        </div>
        Additional Testing Tools
        <div className="ml-3 text-xs py-1 px-2 bg-accent-blue/20 rounded-full text-accent-blue opacity-0 group-hover:opacity-100 transition-medium">
          3 tools available
        </div>
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
      {tools.map((tool, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
          >
            <ToolCard {...tool} />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default AdditionalTools;